import { render, staticRenderFns } from "./article_detail.vue?vue&type=template&id=15f6dfe5&scoped=true"
import script from "./article_detail.vue?vue&type=script&lang=js"
export * from "./article_detail.vue?vue&type=script&lang=js"
import style0 from "./article_detail.vue?vue&type=style&index=0&id=15f6dfe5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f6dfe5",
  null
  
)

export default component.exports